<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button text="" defaultHref="/home"></ion-back-button>
    </ion-buttons>
    <ion-title class="ion-text-center">Profil</ion-title>
    <ion-buttons slot="primary">
      <ion-button (click)="navProfileEdit()">
        <ion-icon slot="icon-only" name="create-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <div class="mainContainer">
    <ng-container *ngIf="profileService.userProfile">

    <!-- Avatar + Name -->
    <div class="hero">
      <div class="avatar-wrap">
        <ion-avatar class="avatar">
          <img *ngIf="profileService.userProfile.photoURL; else placeholder"  [src]="'../../assets/images/avatars/' + profileService.userProfile.photoURL" alt="" />
          <ng-template #placeholder>
            <div class="avatar-placeholder"></div>
          </ng-template>
        </ion-avatar>

        <!-- <ion-button class="edit-fab" color="primary" (click)="openModal()" aria-label="Profil bearbeiten">
          <ion-icon name="camera"></ion-icon>
        </ion-button> -->
      </div>

      <div class="name">{{ profileService.userProfile.displayName }}</div>
      <div class="email">{{ profileService.userProfile.email }}</div>
      <ion-chip class="account-badge" [color]="guestAcc ? 'medium' : 'primary'">
        {{ accountBadge }}
      </ion-chip>
    </div>

    <!-- Credits Card -->
    <ion-card class="credits-card">
      <ion-card-content class="credits-content">
        <div class="credits-left">
          <div class="credits-label">GUTHABEN</div>
          <div class="credits-value">{{ getAvailableSongCount(profileService.userProfile.credits) }}</div>
        </div>

        <ion-button class="topup-btn" (click)="topUpCredits()">
          <ion-icon name="add-circle" slot="start"></ion-icon>
          Aufladen
        </ion-button>
      </ion-card-content>
    </ion-card>

    <!-- Account -->
    <div class="section-title">MEIN KONTO</div>

    <ion-list class="link-list" lines="none">
      <ion-item
        class="link-item"
        button
        detail="true"
        *ngFor="let l of accountLinks; trackBy: trackById"
        (click)="openLink(l.link)"
      >
        <div class="icon-pill" slot="start" aria-hidden="true">
          <ion-icon [name]="l.icon"></ion-icon>
        </div>

        <ion-label>
          <div class="link-title" [class.spacePadding]="!l.subtitle">{{ l.title }}</div>
          <div class="link-subtitle">{{ l.subtitle }}</div>
        </ion-label>
      </ion-item>
    </ion-list>

    <!--
      Rabattcodes aus Bewertungen. Kein eigener Abschnitt, wenn keine da sind -
      eine leere Ueberschrift "Deine Rabattcodes" saehe nach einem Fehler aus.
    -->
    <ng-container *ngIf="rewardCodes.length">
      <div class="section-title">DEINE RABATTCODES</div>

      <div class="rewardCodes">
        <button
          type="button"
          class="rewardCode"
          *ngFor="let r of rewardCodes"
          (click)="copyRewardCode(r.code)"
        >
          <div class="rewardCode__left">
            <div class="rewardCode__code">{{ r.code }}</div>
            <div class="rewardCode__meta">{{ r.percent }} % auf deinen nächsten Song · einmal einlösbar</div>
          </div>
          <ion-icon name="copy-outline" aria-hidden="true"></ion-icon>
        </button>
      </div>
    </ng-container>

    <!-- Support -->
    <div class="section-title">SUPPORT</div>

    <ion-list class="link-list" lines="none">
      <ion-item
        class="link-item"
        button
        detail="true"
        *ngFor="let l of supportLinks; trackBy: trackById"
        (click)="openLink(l.link)"
      >
        <div class="icon-pill" slot="start" aria-hidden="true">
          <ion-icon [class.danger]="l.id === 'logout'" [name]="l.icon"></ion-icon>
        </div>

        <ion-label>
          <div class="link-title" [class.spacePadding]="!l.subtitle" [class.danger]="l.id === 'logout'">{{ l.title }}</div>
          <div class="link-subtitle" *ngIf="l.subtitle">{{ l.subtitle }}</div>
        </ion-label>
      </ion-item>
    </ion-list>

    <!-- Legal -->
    <div class="legal">
      <button type="button" (click)="openLegal('impressum')">Impressum</button>
      <span class="sep">|</span>
      <button type="button" (click)="openLegal('datenschutz')">Datenschutz</button>
      <span class="sep">|</span>
      <button type="button" (click)="openLegal('agb')">AGB</button>
    </div>

    <!--
      Stand der ausgelieferten App. Unauffaellig und ganz unten: das ist eine
      Betreiberinformation, keine Nutzerinformation - aber sie muss ohne
      Entwicklerwerkzeuge erreichbar sein, sonst hilft sie im Zweifelsfall
      niemandem.
    -->
    <div class="buildInfo" *ngIf="buildInfo.build">
      <span *ngIf="appVersion">v{{ appVersion }}</span>
      <span>Build {{ buildInfo.build }}</span>
    </div>

    <div class="bottom-spacer"></div>

    </ng-container>
  </div>
</ion-content>

<!-- <ion-footer>
  <div class="bottomDiv">
    <ion-button *ngIf="guestAcc" expand="block" color="secondary" (click)="convertAnonAcc()">Jetzt verifizieren</ion-button>
    <ion-button *ngIf="!guestAcc" expand="block" color="tertiary" (click)="saveProfileData()">Speichern</ion-button>
  </div>
</ion-footer> -->

